import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["data"];
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import { StyledPropertyCardHomeDetailsList } from './PropertyCardHomeDetailsList.styles';

/**
 * Note: This is for SEO testing purposes only.
 *
 * Displays the home details inside of a `PropertyCard`.
 * While `PropertyCard.HomeDetails` uses `span` elements, this
 * version uses an unordered list.
 *
 * @since 8.79.13
 */
export var PropertyCardHomeDetailsList = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var data = _ref.data,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledPropertyCardHomeDetailsList, _extends({
    ref: forwardedRef
  }, rest), data.map(function (_ref2, index) {
    var label = _ref2.label,
      value = _ref2.value;
    return (
      /*#__PURE__*/
      // eslint-disable-next-line zillow/react/no-array-index-key
      React.createElement("li", {
        key: index
      }, value && /*#__PURE__*/React.createElement("b", null, value), " ", label && label)
    );
  }));
});
PropertyCardHomeDetailsList.propTypes = {
  /**
   * The home details text you’d like to display.
   *
   * `data` takes an array of objects, each with a key/value pair:
   * `[{ value: '4', label: 'bd' }, { value: '3', label: 'ba' }]`
   *
   * `label` and `value` can take a string or a node. You can also leave
   * either one empty.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  data: PropTypes.array.isRequired
};
PropertyCardHomeDetailsList.displayName = 'PropertyCard.HomeDetailsList';